import { productFamilyIdFormat } from "@redotech/redo-model/ids";
import { AttributeSchema } from "@redotech/redo-model/inventory/attributes";
import * as z from "zod/v4";

export const updateShopifyListing = {
  name: "updateShopifyListing" as const,
  input: z.object({
    productFamilyId: productFamilyIdFormat.schema,
    attributes: z.array(AttributeSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
  }),
};
